<div class="card">
	<p-toast></p-toast>
	<p-confirmDialog [style]="{ width: tableConfig.confirmationDialogSize }"></p-confirmDialog>
	<p-table
		#dt
		[value]="data"
		dataKey="id"
		editMode="row"
		[tableStyle]="{ 'min-width': '50rem' }"
		[paginator]="true"
		[rows]="10"
		[showCurrentPageReport]="tableConfig.showCurrentPageReport ? tableConfig.showCurrentPageReport : true"
		[currentPageReportTemplate]="tableConfig.showCurrentPageReport ? tableConfig.currentPageReportTemplate : ''"
		[rowsPerPageOptions]="tableConfig.showRowsPerPageOptions ? tableConfig.rowsPerPageOptions : null"
		[styleClass]="'p-datatable-sm' + ' ' + tableConfig.classStyles"
		[globalFilterFields]="getGlobalFilters()"
	>
		<ng-template pTemplate="caption">
			<div class="row" *ngIf="label">
				<div class="col-md-12 text-center">
					<h4 class="mt-2">{{ label }}</h4>
				</div>
			</div>
			<div class="row">
				<div class="flex col-md-6">
					<span class="p-input-icon-left ml-auto">
						<i class="pi pi-search"></i>
						<input
							[(ngModel)]="searchField"
							pInputText
							type="text"
							class="p-inputtext-sm"
							(input)="applyGlobalFilter($event, dt)"
							placeholder="Search"
						/>
					</span>
				</div>
				<div class="col-md-6 text-right" *ngIf="tableConfig.hasAddButton">
					<button
						[disabled]="tableConfig.disabled"
						class="btn btn-success p-button-sm add-button"
						(click)="addEditRecord(false)"
					>
						<i class="pi pi-plus"></i>
						{{ 'Add ' + tableConfig?.addButtonText }}
					</button>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th *ngFor="let field of model" pSortableColumn="{{ field.key }}" style="width: {{ cellWidth }}%">
					{{ field.label }} <p-sortIcon field="{{ field.key }}"></p-sortIcon>
				</th>
				<th>Actions</th>
			</tr>
		</ng-template>
		<ng-template
			pTemplate="body"
			let-row
			let-editing="editing"
			let-ri="rowIndex"
			let-showSelect="showSelect"
		>
			<tr [pEditableRow]="row">
				<td *ngFor="let field of model">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input
								*ngIf="!field.type"
								pInputText
								type="text"
								[(ngModel)]="row[field.key]"
								[disabled]="field.disabled"
							/>
							<p-dropdown
								*ngIf="field.type === 'select'"
								[options]="field.options"
								appendTo="body"
								[(ngModel)]="row[field.key]"
								[style]="{ width: '100%' }"
								(onChange)="onChange($event, field, row)"
							>
							</p-dropdown>
						</ng-template>
						<ng-template pTemplate="output">
							<ng-container [ngSwitch]="field.DataType">
								<ng-container *ngSwitchCase="'CHECKBOX'">
									<p-inputSwitch
										(onChange)="releaseOnChange($event, row, field)"
										[(ngModel)]="row[field.key]"
									></p-inputSwitch>
								</ng-container>

								<ng-container *ngSwitchCase="'CHIPS'">
									<div class="d-flex flex-wrap align-items-center gap-1">
										<p-chip
											*ngFor="let label of field.getValue(field, row)"
											[label]="label"
											styleClass="small py-1 px-2"
										></p-chip>
									</div>
								</ng-container>

								<ng-container *ngSwitchDefault>
									{{ field.getValue(field, row) }}
								</ng-container>
							</ng-container>
						</ng-template>
					</p-cellEditor>
				</td>
				<td>
					<div class="flex align-items-center justify-content-center gap-2">
						<button
							*ngIf="!editing && integrationExtraData?.showSelect"
							pButton
							pRipple
							type="button"
							icon="pi pi-arrow-right"
							(click)="onRowAction('goTo', row)"
							class="actions-button p-button-rounded p-button-text"
						></button>
						<button
							*ngIf="!editing && !integrationExtraData.editInModal"
							pButton
							pRipple
							type="button"
							pInitEditableRow
							icon="pi pi-pencil"
							(click)="onRowEditInit(row)"
							class="actions-button p-button-rounded p-button-text"
						></button>
						<button
							*ngIf="!editing && integrationExtraData.editInModal"
							pButton
							pRipple
							type="button"
							icon="pi pi-pencil"
							[disabled]="tableConfig.disabled"
							(click)="onRowEditInit(row)"
							class="actions-button p-button-rounded p-button-text"
						></button>
						<button
							*ngIf="editing"
							pButton
							pRipple
							type="button"
							pSaveEditableRow
							icon="pi pi-check"
							(click)="onRowEditSave(row)"
							class="actions-button p-button-rounded p-button-text p-button-success mr-2"
						></button>
						<button
							*ngIf="editing"
							pButton
							pRipple
							type="button"
							pCancelEditableRow
							icon="pi pi-times"
							(click)="onRowEditCancel(row, ri)"
							class="actions-button p-button-rounded p-button-text p-button-danger"
						></button>
						<button
							*ngIf="!editing && tableConfig.hasDeleteAction"
							[disabled]="tableConfig.disabled"
							pButton
							pRipple
							type="button"
							icon="pi pi-trash"
							(click)="onShowDeleteConfirm(row)"
							class="actions-button p-button-rounded p-button-text p-button-danger"
						></button>

						<ng-container *ngIf="tableConfig.hasCustomActions">
							<ng-container *ngFor="let customAction of tableConfig.customActions">
								<button
									pButton
									pRipple
									type="button"
									[ngClass]="customAction.customClass"
									(click)="customEvent(customAction, row)"
								>
									<i class="fas fa-cog"></i>
									<i class="fas fa-arrow-right"></i>
								</button>
							</ng-container>
						</ng-container>
					</div>
				</td>
			</tr>
		</ng-template>

		<ng-template *ngIf="tableConfig.showFooter" class="footer-table" pTemplate="summary">
			<div class="flex align-items-center justify-content-between">
				In total there are {{ data ? data.length : 0 }} {{ tableConfig.title }}.
			</div>
		</ng-template>
	</p-table>
</div>
